import { __awaiter, __extends, __generator, __spreadArrays } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { noop } from '../../common/index';
import { SmartPoller } from '@wix/answers-lib';
export var deprecatedinfiniteScrollKey = 'deprecated-infinite-scroll';
export var DEFAULT_INTERVAL = 10000;
export var defaultBuffer = function (visibleCount) { return Math.ceil(visibleCount / 2); };
/** @deprecated please use \<InfiniteScroll/> */
var DeprecatedInfiniteScroll = /** @class */ (function (_super) {
    __extends(DeprecatedInfiniteScroll, _super);
    function DeprecatedInfiniteScroll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataPoller = noop;
        _this.state = {
            visibleCount: 0,
            topVisible: 0,
            fetching: true,
        };
        _this.updateFromOffset = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, props, state, buffer, offset, topBuffer, data, topOldData, bottomOldData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, props = _a.props, state = _a.state;
                        buffer = props.buffer || defaultBuffer(state.visibleCount);
                        offset = state.topVisible - buffer > 0 ? state.topVisible - buffer : 0;
                        topBuffer = state.topVisible - buffer < 0 ? state.topVisible : buffer;
                        return [4 /*yield*/, props.fetchData(offset, topBuffer + state.visibleCount + buffer)];
                    case 1:
                        data = _b.sent();
                        topOldData = (state.data || []).slice(0, offset);
                        bottomOldData = (state.data || []).slice(offset + topBuffer + state.visibleCount + buffer);
                        this.setState({ data: __spreadArrays(topOldData, data, bottomOldData) });
                        if (this.props.onFetched) {
                            this.props.onFetched();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.initPoller = function () {
            _this.dataPoller = SmartPoller(_this.updateFromOffset, noop, {
                interval: _this.props.pollingInterval || DEFAULT_INTERVAL,
                document: document,
                maxRetries: 10,
                navigator: navigator
            });
        };
        _this.updateFromInitial = function () { return __awaiter(_this, void 0, void 0, function () {
            var props, visibleCount, buffer, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = this.props;
                        visibleCount = Math.ceil(props.listHeight / props.itemHeight);
                        buffer = props.buffer || defaultBuffer(visibleCount);
                        return [4 /*yield*/, props.fetchData(0, visibleCount + buffer)];
                    case 1:
                        data = _a.sent();
                        this.setState({ data: data, visibleCount: visibleCount, fetching: false });
                        if (this.props.onFetched) {
                            this.props.onFetched();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderItem = function (t, idx) {
            var _a = _this, props = _a.props, state = _a.state;
            var buffer = props.buffer || defaultBuffer(state.visibleCount);
            var topRendered = state.topVisible - buffer > 0 ? state.topVisible - buffer : 0;
            var bottomRendered = state.topVisible + state.visibleCount + buffer;
            var item = idx >= topRendered && idx <= bottomRendered ?
                _this.props.renderItem(t) :
                _this.props.renderTombstone();
            return React.createElement("li", { key: idx, className: 'item' }, item);
        };
        _this.renderItems = function () { return React.createElement("ul", null, (_this.state.data || []).map(_this.renderItem)); };
        _this.renderLoadingItems = function () {
            if (_this.state.data && _this.props.renderEmptyState) {
                return _this.props.renderEmptyState();
            }
            else {
                var fullHeightCount = Math.ceil(_this.props.listHeight / _this.props.itemHeight);
                var tombstoneCount = _this.props.tombstoneCount !== undefined && _this.props.tombstoneCount < fullHeightCount ?
                    _this.props.tombstoneCount : fullHeightCount;
                var length_1 = tombstoneCount || 1;
                return React.createElement("ul", null, new Array(length_1).fill(_this.props.renderTombstone()));
            }
        };
        _this.updateOnScroll = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var _a, props, state, scrollTop, topVisible, buffer, offset, topBuffer, remainingScroll, data, topOldData, bottomOldData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, props = _a.props, state = _a.state;
                        scrollTop = e.target.scrollTop;
                        topVisible = Math.floor(scrollTop / this.props.itemHeight);
                        buffer = props.buffer || defaultBuffer(state.visibleCount);
                        offset = topVisible - buffer > 0 ? topVisible - buffer : 0;
                        topBuffer = topVisible - buffer < 0 ? topVisible : buffer;
                        remainingScroll = e.target.scrollHeight - e.target.clientHeight - scrollTop;
                        if (!((Math.abs(topVisible - state.topVisible) > buffer / 2 && !state.fetching) ||
                            scrollTop === 0 ||
                            remainingScroll === 0)) return [3 /*break*/, 2];
                        this.setState({ fetching: true });
                        return [4 /*yield*/, props.fetchData(offset, topBuffer + state.visibleCount + buffer)];
                    case 1:
                        data = _b.sent();
                        topOldData = (state.data || []).slice(0, offset);
                        bottomOldData = (state.data || []).slice(offset + topBuffer + state.visibleCount + buffer);
                        this.setState({ data: __spreadArrays(topOldData, data, bottomOldData), topVisible: topVisible, fetching: false });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    DeprecatedInfiniteScroll.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateFromInitial()];
                    case 1:
                        _a.sent();
                        if (!!this.props.enablePolling) {
                            this.initPoller();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DeprecatedInfiniteScroll.prototype.componentWillUnmount = function () {
        if (!!this.props.enablePolling) {
            this.dataPoller();
        }
    };
    DeprecatedInfiniteScroll.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.props.forceFetch && nextProps.forceFetch) {
            this.props.enablePolling ? this.updateFromInitial() : this.updateFromOffset();
        }
    };
    DeprecatedInfiniteScroll.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var classNames = namespacedClassnames(deprecatedinfiniteScrollKey, props.className);
        return (React.createElement("div", { className: classNames, onScroll: this.updateOnScroll, style: { maxHeight: this.props.listHeight } }, state.data && state.data.length ? this.renderItems() : this.renderLoadingItems()));
    };
    return DeprecatedInfiniteScroll;
}(React.PureComponent));
export { DeprecatedInfiniteScroll };
//# sourceMappingURL=index.js.map